import { SegmentAnchor, SegmentVersion } from 'src/models/anchor-and-version/segment.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-segment-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudSegmentModalComponent extends CrudModalAbstractComponent<
    SegmentAnchor,
    SegmentVersion
> {
    public modalProps: ModalProps = {
        title: 'Segment',
        validateNameFormat: true,
        anchorFields: [],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 2 },
            { field: 'bandwidth', label: 'Bandwidth', type: 'number', defaultValue: 0, order: 3 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 4 },
            { field: 'isPrimary', label: 'Is Primary', type: 'switch', order: 5 },
            {
                field: 'isCanFD',
                label: 'Is CAN FD',
                type: 'switch',
                defaultValue: false,
                order: 6,
            },
        ],
    };
}
